import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell, { authStyles } from "../../../components/usuarios_tienda/AuthShell";
import { solicitarResetCliente } from "../../../services/LoginUserCliente";

const LOGIN_PATH = "/cliente/login";
const COOLDOWN_SEG = 60;

function ForgotPasswordClientePage() {
  const navigate = useNavigate();
  const [correo, setCorreo] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [cooldown, setCooldown] = useState(0);

  // Cuenta regresiva del cooldown (1s).
  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setTimeout(() => setCooldown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const value = correo.trim();
    if (!value) {
      setError("Ingresa tu correo electrónico.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setError("Ingresa un correo electrónico válido.");
      return;
    }

    setSubmitting(true);
    try {
      await solicitarResetCliente(value);
      setSent(true);
      setCooldown(COOLDOWN_SEG);
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || "No se pudo procesar la solicitud.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleResend = async () => {
    if (cooldown > 0 || submitting) return;
    setError("");
    setSubmitting(true);
    try {
      await solicitarResetCliente(correo.trim());
      setCooldown(COOLDOWN_SEG);
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || "No se pudo reenviar el enlace.");
    } finally {
      setSubmitting(false);
    }
  };

  if (sent) {
    return (
      <AuthShell title="Revisa tu correo" subtitle="Te enviamos las instrucciones.">
        <div style={{ ...authStyles.alert, background: "transparent", border: "none", color: "#5f6b85", padding: "4px 0" }}>
          Si el correo está registrado, recibirás un enlace para restablecer tu contraseña. El enlace vence en 1 hora.
        </div>

        {error && (
          <p style={{ color: "#dc2626", fontSize: 13.5, fontWeight: 600, textAlign: "left", margin: "0 0 14px" }}>
            {error}
          </p>
        )}

        <button
          type="button"
          onClick={handleResend}
          disabled={cooldown > 0 || submitting}
          style={{
            ...authStyles.primaryBtn,
            opacity: cooldown > 0 || submitting ? 0.6 : 1,
            cursor: cooldown > 0 || submitting ? "default" : "pointer",
          }}
        >
          {cooldown > 0 ? `Reenviar en ${cooldown}s` : submitting ? "Enviando…" : "Reenviar enlace"}
        </button>

        <div style={{ marginTop: 16 }}>
          <button type="button" style={authStyles.link} onClick={() => navigate(LOGIN_PATH)}>
            Volver al inicio de sesión
          </button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="¿Olvidaste tu contraseña?"
      subtitle="Ingresa tu correo y te enviaremos un enlace para restablecerla."
    >
      {error && (
        <p style={{ color: "#dc2626", fontSize: 13.5, fontWeight: 600, textAlign: "left", margin: "0 0 14px" }}>
          {error}
        </p>
      )}

      <form onSubmit={handleSubmit} noValidate>
        <div style={authStyles.field}>
          <label style={authStyles.label}>Correo electrónico</label>
          <input
            type="email"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            style={authStyles.input}
            placeholder="tu@correo.com"
            autoFocus
          />
        </div>
        <button type="submit" style={{ ...authStyles.primaryBtn, opacity: submitting ? 0.8 : 1 }} disabled={submitting}>
          {submitting ? "Enviando…" : "Enviar enlace"}
        </button>
      </form>

      <div style={{ marginTop: 16 }}>
        <button type="button" style={authStyles.link} onClick={() => navigate(LOGIN_PATH)}>
          Volver al inicio de sesión
        </button>
      </div>
    </AuthShell>
  );
}

export default ForgotPasswordClientePage;
